const locale = {
  on: 'ON',
  off: 'OFF'
};
export default locale;